import TableActionsPanel from './TableActionsPanel';

export default TableActionsPanel;
